import { faqItems } from '@/mocks/faq';

export default function FAQSection() {
  return (
    <section id="faq" className="bg-background-100 py-14">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-foreground-500 text-sm">
            关于黑料入口，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <details
              key={index}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
            >
              <summary className="flex items-center justify-between p-5 cursor-pointer font-medium text-foreground-900 text-sm hover:text-primary-600 transition-colors list-none">
                <span className="pr-4">{item.question}</span>
                <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center text-foreground-400 group-open:rotate-180 transition-transform">
                  <i className="ri-arrow-down-s-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}